import { SanityPage } from '~/types';
import { useSettingsStore } from '~/stores/useSettingsStore';
import getPageQuery from '~/queries/getPageQuery';

export const useFetchPage = async (): Promise<SanityPage | null> => {
  const sanity = useSanity();
  const route = useRoute();
  const i18n = useI18n();
  const { primeMedia } = useSanityMediaLoader();
  const settings = useSettingsStore().settings;
  const query = getPageQuery(route.path, i18n.locale.value);
  const { data } = await useAsyncData<SanityPage>(route.fullPath, () =>
    cachedSanityFetch(sanity, query)
  );

  if (!data.value) {
    throw createError({
      statusCode: 404,
      message: 'Page not found'
    });
  }

  // images and videos of the page, header and footer are resolved in a single query
  await primeMedia(data.value, settings.siteParts);

  return data.value;
};
